// extracted by mini-css-extract-plugin
export default {"block":"operator_block__6Sazl","title":"operator_title__x1HQ9","active":"operator_active__2Si2P"};